import svg4everybody from 'svg4everybody';

export default function() {
    svg4everybody();

    const pdfLinks = document.querySelectorAll('a[href$=".pdf"]');
    pdfLinks.forEach(link => {
        link.target = '_blank';
    });
}
